
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { SectionContainer } from '@/components/section/SectionContainer';
import ContactForm from '@/components/contact/ContactForm';
import ScrollToTop from '@/components/ScrollToTop';

const Contact = () => {
  return <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-24 md:pt-32 pb-16 min-h-screen">
        {/* Header Section */}
        <section className="py-0">
          <SectionContainer containerWidth="medium">
            <div className="text-center max-w-3xl mx-auto mb-12">
              <div className="inline-flex items-center justify-center px-4 mb-6 rounded-full bg-[#FEE6D8] text-[#003a70] text-sm font-medium py-[9px] my-[23px]">
                Get in Touch
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#003a70] mb-6">
                Contact Us
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Have questions about our product? Need help with your account? 
                We're here to assist you. Fill out the form below and we'll get back to you as soon as possible.
              </p>
            </div>
          </SectionContainer>
        </section>

        {/* Mascot Section - Reduced spacing */}
        <section className="pb-2">
          <SectionContainer containerWidth="narrow">
            <div className="flex justify-center">
              <div className="rounded-full bg-[#003a70] p-4 md:p-6 relative w-32 h-32 md:w-40 md:h-40 flex items-center justify-center overflow-hidden">
                <img 
                  src="/lovable-uploads/6886c7fe-b255-4706-8aa7-67fc1814a4a6.png" 
                  alt="AskSpot Mascot" 
                  className="w-28 h-28 md:w-36 md:h-36 object-contain"
                  width={144}
                  height={144}
                  loading="eager"
                />
              </div>
            </div>
          </SectionContainer>
        </section>

        {/* Contact Form Section - Reduced spacing at top */}
        <section className="pt-2 pb-8 mb-12">
          <SectionContainer containerWidth="narrow">
            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6 md:p-8">
              <ContactForm />
            </div>
          </SectionContainer>
        </section>
      </main>
      <Footer />
    </>;
};
export default Contact;
